import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../../common/services/cqs/IPrimaryKey";
import { IVKAtgardKedjaKoppling } from "../../models/Atgardskedjor/atgardskedjor-models";

export abstract class AtgardKedjaBaseCommand extends BasicCommand<AtgardKedjaBaseCommand> {
    kedjaRowVersion: string;
    kontraktGuid: string;
    kedjaGuid: string;
    atgardKedjaKopplingar: IVKAtgardKedjaKoppling[];
    static readonly $groupKey = "virkeskopatgardkedja";

    get primaryKey(): IUpdateAtgardKedjaPrimaryKey {
        return {
            kontraktGuid: this.kontraktGuid,
            kedjaGuid: this.kedjaGuid
        };
    }

    constructor(kedjaRowVersion: string, kontraktGuid: string,
        kedjaGuid: string, atgardKedjaKopplingar: IVKAtgardKedjaKoppling[],
        $type: string, commandType: CommandType) {
        super($type, AtgardKedjaBaseCommand.$groupKey, commandType);
        this.kedjaRowVersion = kedjaRowVersion;
        this.kontraktGuid = kontraktGuid;
        this.kedjaGuid = kedjaGuid;
        this.atgardKedjaKopplingar = atgardKedjaKopplingar;
    }
}

export interface IUpdateAtgardKedjaPrimaryKey extends IPrimaryKey<IUpdateAtgardKedjaPrimaryKey> {
    kontraktGuid: string;
    kedjaGuid: string;
}
